import variables from '../../scss/theme-variables.scss';

const colors = Object.keys(variables);
const colorsValue = Object.values(variables);

// These numbers need to be updated within the .slice
// when adding or removing colours in styleguideAddOn/theme-variables.scss
const palette = colors.slice(0, 20);
const paletteValue = colorsValue.slice(0, 20);
const theme = colors.slice(20, 32);
const themeValue = colorsValue.slice(20, 32);

document.addEventListener('DOMContentLoaded', () => {
	const selectChoices = new window.od.SelectChoices('.choices-select');
	selectChoices.init();
});

for (let i = 0; i < paletteValue.length; i++) {
	let colourPalette = '';
	colourPalette += `<li><div class='square' style='background-color: ${paletteValue[i]}'><p>$${palette[i]}</p></div></li>`;
	document.getElementById('color-palette').innerHTML += colourPalette;
}

for (let i = 0; i < themeValue.length; i++) {
	let themePalette = '';
	themePalette += `<li><div class='square' style='background-color: ${themeValue[i]}'><p>$${theme[i]}</p></div></li>`;
	document.getElementById('theme-palette').innerHTML += themePalette;
}
